import { Api } from '@/services/AxiosService'
import { EMPTY_FLAT_FILTER } from '@/helper/emptyFilters'
import { deepCopy, convertedPrice } from '@/helper'
const isEqual = require('lodash.isequal')
const actions = {
  async fetchFlatsList({ commit, getters }) {
    const params = {
      ...getters.getFlatsFilter,
      price: convertedPrice(getters.getFlatsFilter.price),
      sort: getters.getFlatsSorting,
      page: getters.getFlatsPagination.page,
    }

    const { data } = await Api.fetchFlatsList({ params })
    commit('setFlats', data)
  },

  changeFlatsSorting(ctx, data) {
    ctx.commit('setFlatPagination', { page: 1 })
    ctx.commit('setFlatSorting', data)
    ctx.dispatch('fetchFlatsList')
  },
  async changeFlatsPagination(ctx, data) {
    ctx.commit('setFlatPagination', data)
    await ctx.dispatch('fetchFlatsList')
  },
  changeFlatsFilter(ctx, newValue) {
    ctx.commit('setFlatPagination', { page: 1 })
    ctx.commit('setFlatFilter', newValue)
    ctx.dispatch('fetchFlatsList')
  },
}
const mutations = {
  setFlats(state, { data, meta: { per_page, current_page, total } }) {
    state.flatsList = data
    state.pagination = {
      limit: per_page,
      page: current_page,
      total: total,
    }
  },
  setFlatPagination(state, { page }) {
    state.pagination.page = page
  },
  setFlatSorting(state, data) {
    state.sort = data
  },
  setFlatFilter(state, newValue) {
    if (newValue === null) {
      // if remove all button is clicked
      state.filter = deepCopy(state.defaultFilter)
      state.isFilterUsed = false
      return
    }
    state.filter = { ...state.filter, ...newValue }
    //check if need to show remove btn
    state.isFilterUsed = !isEqual(state.filter, state.defaultFilter)
  },
  setDefaultFlatFilter(state, filter) {
    //setting dynamic filter params from backend admin panel
    const newFilter = deepCopy(filter)
    Object.keys(newFilter.rooms).forEach((v) => (newFilter.rooms[v] = false))
    Object.keys(newFilter.floor).forEach((v) => (newFilter.floor[v] = false))
    Object.keys(newFilter.material).forEach(
      (v) => (newFilter.material[v] = false)
    )

    state.defaultFilter = deepCopy({
      ...EMPTY_FLAT_FILTER,
      rooms: newFilter.rooms,
      floor: newFilter.floor,
      material: newFilter.material,
    })
    state.defaultFilter.price = newFilter.price
    state.defaultFilter.area = newFilter.area
    state.filter = deepCopy(state.defaultFilter)
  },
  setConvertedPriceFilter(state, price) {
    state.defaultFilter.price = price
    state.filter.price = price
  },
}
const getters = {
  getFlatsList(state) {
    return state.flatsList
  },

  getFlatsSorting(state) {
    return state.sort
  },
  getFlatsPagination(state) {
    return state.pagination
  },
  getFlatsFilter(state) {
    return state.filter
  },
  getDefaultFlatsFilter(state) {
    return state.defaultFilter
  },
  isFlatFilterUsed(state) {
    return state.isFilterUsed
  },
}
const state = {
  flatsList: [],
  filter: {},
  defaultFilter: {},
  isFilterUsed: false,
  sort: 'new',
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
